export default {
  title: "Онлайн-каталог",
  tabs: {
    products: "Тауарлар мен қызметтер",
    categories: "Санаттар",
  },
  buttons: {
    qrCode: "QR - код",
    create: "Құру",
  },
  modals: {
    limit: {
      title: "Сіз тарифіңіздегі тауарлардың максималды санын құрдыңыз",
      subtitle: "Көбірек тауар құру үшін тарифті жоғарылатңыз.",
      cancel: "Болдырмау",
      toTariffs: "Тарифтерге",
    },
  },
  statuses: {
    allProducts: "Барлық тауарлар",
    allCategories: "Барлық санаттар",
    confirmed: "Расталғандар",
    moderation: "Модерацияда",
    rejected: "Қабылданбағандар",
    basic: "Негізгі",
  },
  emptyState: {
    products: {
      noTradingPoints: {
        title: "Онлайн-каталогта әлі тауарлар жоқ",
        description:
          "Алдымен сауда нүктесін құрыңыз, содан кейін тауарларды қосуға болады",
        buttonText: "Сауда нүктелеріне",
      },
      noProducts: {
        title: "Онлайн-каталогта әлі тауарлар жоқ",
        buttonText: "Тауар құру",
      },
    },
    categories: {
      title: "Деректер әлі жоқ",
      description:
        "Олар тауар құрып, оны негізгі санаттардың біріне жалғағаннан кейін немесе пайдаланушы санатын құрғаннан кейін пайда болады.",
      buttonText: "Санат құру",
    },
  },
  formErrors: {
    empty: "Өріс бос болмауы керек",
    price: "0-ден үлкен мән көрсету керек",
    discount: "Жеңілдіксіз бағадан кіші мән көрсету керек",
  },
  exitModal: {
    creating: {
      title: "Тауар құруды болдырмау керек пе?",
      subtitle:
        "Енгізілген тауар туралы ақпарат сақталмайды. Өңдеуге оралу үшін «Артқа» басыңыз.",
      backButton: "Артқа",
      confirmButton: "Ия, болдырмау",
    },
    editing: {
      title: "Енгізілген өзгерістерді жою керек пе?",
      subtitle:
        "Егер оларды сақтау қажет болса, артқа оралыңыз. Әйтпесе барлық енгізілген өзгерістер қолданылмайды. Тауар карточкасында бұрын сақталған деректер көрсетіледі.",
      backButton: "Қайту және сақтау",
      confirmButton: "Жою",
    },
  },
  categoryEditModal: {
    title: {
      rejected: "Санат модератор арқылы қабылданбады",
      default: "Санат атауын көрсетіңіз",
    },
    subtitle: {
      rejected: "Атауын өзгертіп, санатты модерацияға жіберіңіз.",
      rejectedWithMessage: "Атауын өзгертіп, санатты модерацияға жіберіңіз.",
      default:
        "Санат жаңа тауарлар құру кезінде таңдауға қолжетімді болады және RC PAY-те көрсетілген атауымен тек модерациядан өткеннен кейін көрсетіледі.",
    },
    buttons: {
      cancel: "Болдырмау",
      sendForModeration: "Модерацияға",
    },
    notification: {
      success: "Санат модерацияға жіберілді",
    },
  },
  categoryDeleteModal: {
    title: "«{name}» санатын жоюға сенімдісіз бе?",
    subtitle: "Оған жататын тауарларға негізгі «Санатсыз» мәні беріледі",
    buttons: {
      cancel: "Болдырмау",
      delete: "Жоу",
    },
    notification: {
      deleted: "Санат жойылды",
    },
  },
  productCard: {
    labels: {
      name: "Тауар атауы",
      category: "Санат",
      measurementUnit: "Өлшем бірлігі",
      price: "Бағасы, {currency}",
      discountPrice: "Жеңілдікпен баға, {currency}",
      sku: "Артикул",
      barcode: "Штрихкод",
      description: "Сипаттама",
      tradingPointsVisibility: "Сауда нүктелерінде көрсету",
      productImages: "Тауар суреттері",
      showInCatalog: "Тауарды Онлайн-каталогта көрсету",
      showInCatalogDescription:
        "Тауар модерациядан өткеннен кейін таңдалған сауда нүктелерінің Онлайн-каталогында RC PAY-те көрсетіледі.",
    },
    placeholders: {
      selectCategory: "Санатты таңдаңыз",
      selectMeasurementUnit: "Өлшем бірлігін таңдаңыз",
      sku: "30 таңбаға дейін",
      selectTradingPoints: "Сауда нүктелерін таңдаңыз",
    },
    buttons: {
      cancel: "Болдырмау",
    },
    notifications: {
      fillRequiredFields: "Барлық міндетті өрістерді дұрыс толтырыңыз",
      savedAndSentForModeration:
        "Өзгерістер сақталды және модерацияға жіберілді",
      successfullySaved: "Өзгерістер сәтті сақталды",
    },
    moderationMessage: {
      title: "Модерациядан хабарлама",
    },
    measurementUnits: {
      none: "Өлшем бірліктері жоқ",
    },
    imageRequirements: {
      aspectRatio: "Сурет пішімділігі — 1:1",
      fileTypes: "JPEG, JPG, PNG — әрқайсысы 10 МБ-тан аспайтын 5 файлға дейін",
    },
    imageCropper: {
      subtitle:
        "Таңдалған аймақ RC PAY-тегі Онлайн-каталогтағы тауар карточкасында көрсетіледі.",
    },
  },
  productsTableHeader: {
    columns: {
      name: "Атауы",
      category: "Санат",
      price: "Баға",
      status: "Статус",
    },
  },
  productsDeleteModal: {
    title: "Көрсетілген тауарды жоюға сенімдісіз бе?",
    buttons: {
      cancel: "Болдырмау",
      delete: "Жою",
    },
  },
  productsQRModal: {
    title: "Мәзірге арналған QR-код",
    subtitle:
      "Онлайн-каталогының QR-кодын жүктеп алғыңыз келетін сауда нүктесін таңдаңыз",
    tradingPoint: "Сауда нүктесі",
    downloadButton: "QR-кодты жүктеу",
  },
  productsSaveModal: {
    title: "Енгізілген өзгерістердің кейбіреуі модерацияны талап етеді",
    subtitle:
      "RC PAY-те көрсетілетін тауар карточкасында олар тек тексеріліп, модератор растағаннан кейін жаңартылады.",
    buttons: {
      cancel: "Болдырмау",
      sendForModeration: "Модерацияға",
    },
  },
  productVisible: {
    messages: {
      visible: "RC PAY-те көрсетіледі",
      hidden: "RC PAY-те жасырылған",
    },
  },
  categoriesFilters: {
    sort: {
      newFirst: "Алдымен жаңа құрылғандар",
      alphabeticalAsc: "Атауы бойынша А-дан Я-ға дейін",
      alphabeticalDesc: "Атауы бойынша Я-дан А-ға дейін",
      productsCountAsc: "Алдымен аз тауарлар",
      productsCountDesc: "Алдымен көп тауарлар",
    },
    buttons: {
      create: "Құру",
    },
    search: {
      placeholder: "Санаттар бойынша іздеу",
    },
    status: {
      label: "Санат статусы",
    },
  },
  productFilters: {
    sort: {
      newFirst: "Алдымен жаңа құрылғандар",
      alphabeticalAsc: "Атауы бойынша А-дан Я-ға дейін",
      alphabeticalDesc: "Атауы бойынша Я-дан А-ға дейін",
      priceAsc: "Бағасы өспелі",
      priceDesc: "Бағасы кемімелі",
    },
    buttons: {
      create: "Құру",
    },
    search: {
      placeholder: "Іздеу",
    },
    labels: {
      category: "Санат",
      tradingPoints: "Сауда нүктелері",
      status: "Статус",
    },
  },
  productDrawer: {
    title: {
      edit: "Тауар туралы ақпарат",
      create: "Тауар құру",
    },
    saveButton: {
      saveAndExit: "Сақтау және шығу",
      sendForModeration: "Модерацияға",
    },
    errors: {
      imageUpload:
        "Кейбір суреттерді өңдеу мүмкін болмады. Басқаларын жүктеп көріңіз.",
    },
  },
};
